import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from "@angular/core";
import {IntraEbHistory} from "../../../../shared/sdk/models";
import {colorsHistory} from "../../models/consteBoarding";

import moment from 'moment';
import {interval} from "rxjs";
import {map} from "rxjs/operators";
import {AsyncPipe, NgClass, NgStyle, TitleCasePipe} from '@angular/common';
import {PeoplePartial} from '../../../../core/directives/partials/people/people.partial';

export class IntraEbHistoryTimer extends IntraEbHistory{
  "from": any;
  "counter":any;
}

@Component({
  selector: 'eventAction',
  templateUrl: './eventAction.directive.html',
  imports: [
    NgClass,
    NgStyle,
    TitleCasePipe,
    PeoplePartial,
    AsyncPipe
  ]
})
export class EventActionDirective implements OnInit, OnChanges, OnDestroy{

  public moment=moment;
  public colorsHistory = colorsHistory
  @Input('event') event: IntraEbHistory = null;
  @Input('padding') padding: boolean = true;
  @Input('showPeopleTitle') showPeopleTitle: boolean = false;


  constructor(

  ) {

  }

  private setTimer(){
    this.event['from'] = Math.abs(moment().utc(false).diff(moment(this.event.date, 'YYYY-MM-DD H:mm:ss').utc(false), 'seconds'));
    this.event['counter'] = interval(1000).pipe(
      map((x) => {
        return this.event['from'] += 1;
      })
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["event"].currentValue){
      this.setTimer();
    }
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {

  }


}

